import { RootState } from '@atredux/store'

export const getAccessToken = (state: RootState): string => state.loginTokenInfo._accessToken

export const getRefreshToken = (state: RootState): string => state.loginTokenInfo._refreshToken

export const getIdToken = (state: RootState): string => state.loginTokenInfo._idToken

export const getTokenType = (state: RootState): string => state.loginTokenInfo._tokenType

export const getTokenExpiry = (state: RootState): number => state.loginTokenInfo._tokenExpiry

export const getRefreshTokenCallbackTime = (state: RootState): number => state.loginTokenInfo._refreshTokenCallbackTime

export const getIsLoggedIn = (state: RootState): boolean => state.loginTokenInfo._isLoggedIn
